import React, { Component } from 'react';
import firebase from 'firebase';

class SignOut extends Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    firebase.auth().signOut();
  }

  render() {
    return <div>sign out</div>;
  }
}
export default SignOut;
